import React from 'react'

import { useSelector } from 'react-redux'

import { BrandedContentAdStatusTypes } from '@enums'
import { IApplicationState } from '@store'
import {
  selectTransactedBrandedContentAd,
  selectTransactedBrandedContentAdStatus,
} from '@store/submissions'
import { isEmpty } from '@utils'
import ButtonPendingCreatorApproval from './PendingCreatorApproval'
import ButtonRequestGranted from './RequestGranted'
import ButtonRequestPricing from './RequestPricing'
import ButtonRightsDeclined from './RightsDeclined'
import ButtonRightsExpired from './RightsExpired'
import ButtonRightsRequested from './RightsRequested'

interface IProps {
  submissionId: number
}

const BrandedContentAdFormButton: React.FC<IProps> = ({ submissionId }) => {
  const bcaStatus = useSelector((state: IApplicationState) =>
    selectTransactedBrandedContentAdStatus(state, submissionId),
  )
  const hasBcaTransaction = useSelector(
    (state: IApplicationState) => !isEmpty(selectTransactedBrandedContentAd(state, submissionId)),
  )

  if (!hasBcaTransaction) {
    return <ButtonRequestPricing />
  }

  switch (bcaStatus) {
    case BrandedContentAdStatusTypes.PendingCreatorApproval:
      return <ButtonPendingCreatorApproval />
    case BrandedContentAdStatusTypes.Requested: {
      return <ButtonRightsRequested />
    }
    case BrandedContentAdStatusTypes.Declined: {
      return <ButtonRightsDeclined />
    }
    case BrandedContentAdStatusTypes.Completed:
    case BrandedContentAdStatusTypes.Approved: {
      return <ButtonRequestGranted />
    }
    case BrandedContentAdStatusTypes.Expired: {
      return <ButtonRightsExpired />
    }
  }
}

export { BrandedContentAdFormButton }
export default BrandedContentAdFormButton
